import { all, takeLatest, call, put } from 'redux-saga/effects';
import { push } from 'react-router-redux'
import { 
  SIGN_IN_REQUEST, 
  SIGN_IN_SUCCESS, 
  SIGN_IN_FAILURE, 
  RESEND_VERIFICATION_REQUEST, 
  RESEND_VERIFICATION_SUCCESS, 
  RESEND_VERIFICATION_FAILURE 
} from './constants';
import { resendVerificationEmail } from 'utils/api'; 
import { signInFailure, signInSuccess } from './actions';
import { apiSaga } from 'sagas';
import { postSession } from 'utils/api';
import { setItem } from 'utils/localStorage';

import { setAuthToken } from 'containers/App/actions';
import { getSessionFlow } from 'containers/App/sagas';
import { setModal } from 'containers/RootModal/actions';
import { LOGIN_ERROR, UNVERIFIED_EMAIL_MODAL } from 'containers/RootModal/constants';
import { startSubmit, stopSubmit } from 'redux-form';

export function* signInFlow({ payload }) {
  yield put(startSubmit('signIn'));
  yield* apiSaga(postSession, [payload], signInSuccess, signInFailure);
  yield put(stopSubmit('signIn'))
}

export function* authenticate({ payload }) {
  yield all([
    put(setAuthToken(payload.authentication_token)),
    call(setItem, 'authToken', payload.authentication_token),
    put(push('/')),
  ]);

  yield* getSessionFlow();
}

export function* putLoginError({payload}) {
  if (payload.message !== "Password is no longer valid")  {
  let modalType = payload.not_confirmed ? UNVERIFIED_EMAIL_MODAL : LOGIN_ERROR 
  yield put(setModal({ modalType: modalType }));
  }
  else yield put(push(`/forgot-password?update_password_token=${payload.token}`));
}

export function* putResendVerificationRequest(payload) {
  put(resendVerificationEmail(payload));
}

export function* putResendVerificationSuccess() {
  // console.log("to be done/deleted if further action is required")
}

export function* putResendVerificationFailure() {
  // console.log("to be done/deleted if further action is required")

}

export default function* watchSignIn() {
  yield all([
    takeLatest(SIGN_IN_REQUEST, signInFlow),
    takeLatest(SIGN_IN_SUCCESS, authenticate),
    takeLatest(SIGN_IN_FAILURE, putLoginError),
    takeLatest(RESEND_VERIFICATION_REQUEST, putResendVerificationRequest),
    takeLatest(RESEND_VERIFICATION_SUCCESS, putResendVerificationSuccess),
    takeLatest(RESEND_VERIFICATION_FAILURE, putResendVerificationFailure),
  ]);
}



// WEBPACK FOOTER //
// ./src/containers/SignInPage/sagas.js